(function () {
  // === CONFIG ===
  // ID de la section "deal du jour" (featured product) sur la home
  // (tu peux le rendre dynamique plus tard si tu changes l’id)
  const SECTION_ID =
    'shopify-section-template--25769142321537__featured_product_information_dM7LFX';

  // --- Helpers ---
  function $(sel, root = document) {
    return root.querySelector(sel);
  }

  function getSectionRoot() {
    return document.getElementById(SECTION_ID);
  }

  function getDealPfc(root) {
    return root ? $('product-form-component', root) : null;
  }

  function getVariantPicker(root) {
    // Ici ton HTML contient variant-picker[data-section-id="template--...__featured_product_information_dM7LFX"]
    // mais le plus robuste = chercher dans la section.
    return root ? $('variant-picker', root) : null;
  }

  function getFreeGrams(root) {
    const picker = getVariantPicker(root);
    if (!picker) return 0;

    const checked = picker.querySelector(
      'input[type="radio"][data-variant-id]:checked'
    );
    if (!checked) return 0;

    const label = checked.closest('label');
    if (!label) return 0;

    // Ton badge est bien: .custom-variant-label__badge-right .custom-variant-badge
    const badge = label.querySelector(
      '.custom-variant-label__badge-right .custom-variant-badge'
    );
    const txt = (badge?.textContent || '').toLowerCase();

    const m = txt.match(/\+?\s*([0-9]+)\s*g/);
    if (!m) return 0;

    const n = Number(m[1]);
    return Number.isFinite(n) ? n : 0;
  }

  function setHidden(root, grams) {
    const pfc = getDealPfc(root);
    if (!pfc) return;

    const form = pfc.querySelector(
      'form[action="/cart/add"], form[action*="/cart/add"]'
    );
    if (!form) return;

    const input = form.querySelector('[data-offer-free-grams]');
    if (!input) return;

    input.value = grams > 0 ? `${grams}g` : '';
  }

  // Double RAF pour laisser le temps au thème de re-render
  function applyWhenStable() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const root = getSectionRoot();
        if (!root) return;

        const grams = getFreeGrams(root);
        setHidden(root, grams);
      });
    });
  }

  function init() {
    const root = getSectionRoot();
    if (!root) return; // pas la home / section absente

    // 1) initial
    applyWhenStable();

    // 2) changement de variante : on écoute UNIQUEMENT dans la section
    root.addEventListener(
      'change',
      (e) => {
        const radio = e.target?.closest?.('input[type="radio"][data-variant-id]');
        if (!radio) return;
        applyWhenStable();
      },
      true
    );

    // 3) filet de sécurité sur click ATC (dans la section uniquement)
    root.addEventListener(
      'click',
      (e) => {
        const btn = e.target?.closest?.('button[type="submit"], button[name="add"]');
        if (!btn) return;

        const form = btn.closest('form[action="/cart/add"], form[action*="/cart/add"]');
        if (!form) return;

        applyWhenStable();
      },
      true
    );

    // 4) preuve de robustesse : observer UNIQUEMENT la section
    const mo = new MutationObserver(() => {
      // Le thème remplace des morceaux => on recalcule
      applyWhenStable();
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
